import React, { FC } from 'react';

import { Spin } from 'antd';

import { useTranslate } from '@/hooks/use-translate';
import { DocData } from '@/types/legal';

import { DocumentCard } from '../DocumentCard/DocumentCard';
import { en } from '../en';

import styles from './ImportantDocuments.module.scss';

type Props = {
	documents: DocData[];
};

const docsDescription: Record<string, { title: string; description: string }> = {
	mfp_policy: {
		title: 'Политика конфиденциальности',
		description: 'Политика обработки персональных данных ООО «Мой Фиш Плэйс»',
	},
	term_of_use: {
		title: 'Лицензионный договор',
		description: 'Лицензионный договор-оферта на право использования программы «Fishplace.ru»',
	},
	user_agreement: {
		title: 'Пользовательское соглашение',
		description: 'Пользовательское соглашение (договор присоединения) ООО «Мой Фиш Плэйс»',
	},
	tech_stack: {
		title: 'Технологический стек',
		description: 'Средства реализации и функционирования ПО «Fishplace.ru»',
	},
	fishplace_user_manual: {
		title: 'Руководство пользователя',
		description: 'Инструкция по использованию платформы',
	},
	fishplace_functional_features: {
		title: 'Функциональные характеристики ПО',
		description: 'Описание функциональных характеристик платформы',
	},
	fishplace_setup: {
		title: 'Установка экземпляра ПО',
		description: 'Инструкция по установке платформы',
	},
	fishplace_lifecycle: {
		title: 'Жизненный цикл ПО',
		description: 'Описание процессов обеспечения жизненного цикла',
	},
};

export const ImportantDocuments: FC<Props> = ({ documents }) => {
	const t = useTranslate(en);

	return (
		<section className={styles.importantDocumentsSection}>
			<div className={styles.content}>
				<h2 id="importantDocument" className={styles.subtitle}>
					{t('Важные документы')}
				</h2>
				{documents.length ? (
					<div className={styles.documentsList}>
						{documents.map((doc) => (
							<DocumentCard
								key={doc.title}
								title={t(docsDescription[doc.title_en].title)}
								url={doc.file}
								description={t(docsDescription[doc.title_en].description)}
							/>
						))}
					</div>
				) : (
					<Spin size="large" />
				)}
			</div>
		</section>
	);
};
